import WachatSpace from './wachat_space';
import {
  get_date_from_now,
  mark_message_read,
  get_time,
  get_avatar_html,
  set_notification_count,
} from './wachat_utils';

export default class WachatRoom {
  constructor(opts) {
    this.$wrapper = opts.$wrapper;
    this.$wachat_rooms_container = opts.$wachat_rooms_container;
    this.wachat_list = opts.wachat_list;
    this.profile = opts.element;

    this.limit_start = 0;
    this.page_length = 20;
    this.loading = false;
    this.setup();
    if (!this.profile.is_read) {
      set_notification_count('increment');
    }
  }

  setup() {
    this.$wachat_room = $(document.createElement('div'));
    this.$wachat_room.addClass('wachat-room');

    this.avatar_html = get_avatar_html(
      this.profile.room_type,
      this.profile.opposite_person_email,
      this.profile.room_name
    );

    let last_message = this.sanitize_last_message(this.profile.last_message);

    const info_html = `
			<div class='wachat-profile-info'>
				<div class='wachat-name'>
					<div class='wachat-latest' 
						style='display: ${this.profile.is_read ? 'none' : 'inline-block'}'
					></div>
					${__(this.profile.room_name)}..
				</div>
				<div style='color: ${
          this.profile.is_read ? 'var(--text-muted)' : 'var(--text-color)'
        }' class='last-message'>${__(last_message)}</div>
			</div>
		`;
    const date_html = `
			<div class='wachat-date'>
				${__(get_date_from_now(this.profile.last_date, 'room'))}
			</div>
		`;
    let inner_html = '';

    inner_html += this.avatar_html + info_html + date_html;

    this.$wachat_room.html(inner_html);
  }

  addLoadMoreButton() {
    // if (this.$load_more_btn) return;

    $('.wachat-load-more-wrap').remove();

    this.$load_more_btn = $(`
        <div class="wachat-load-more-wrap">
          <button class="wachat-load-more-btn">Load More</button>
        </div>
    `);

    this.$wachat_rooms_container.after(this.$load_more_btn);

    this.$load_more_btn.on('click', () => {
      this.fetchMoreRooms();
    });
  }

  fetchMoreRooms() {
    if (this.loading) return;
    this.loading = true;

    this.limit_start += this.page_length;

    this.$load_more_btn.find('button').text('Loading...');

    frappe.call({
      method: 'wachat.api.room.get',
      args: {
        email: frappe.session.user,
        limit_start: this.limit_start,
        limit_page_length: this.page_length
      },
      callback: r => {
        const rooms = r.message || [];

        if (rooms.length === 0) {
          this.$load_more_btn.find('button').text('No more chats');
          this.loading = false;
          return;
        }

        rooms.forEach(profile => {
          const room = new WachatRoom({
            $wrapper: this.$wrapper,
            $wachat_rooms_container: this.$wachat_rooms_container,
            wachat_list: this.wachat_list,
            element: profile
          });

          room.render('append'); // append safely
        });

        this.$load_more_btn.find('button').text('Load More Chats');
        this.loading = false;
      }
    });
  }



  sanitize_last_message(message) {
    let sanitize_last_message = $('<div>').text(message).html();
    if (sanitize_last_message) {
      if (sanitize_last_message.length > 20) {
        sanitize_last_message = sanitize_last_message.substring(0, 20) + '...';
      }
    }
    return sanitize_last_message;
  }

  set_as_read() {
    this.profile.is_read = 1;
    this.$wachat_room.find('.last-message').css('color', 'var(--text-muted)');
    this.$wachat_room.find('.wachat-latest').hide();
    set_notification_count('decrement');
  }

  set_last_message(message, date) {
    const sanitized_message = this.sanitize_last_message(message);
    this.$wachat_room.find('.last-message').html(__(sanitized_message));
    this.$wachat_room.find('.wachat-date').text(__(get_time(date)));
  }

  set_as_unread() {
    if (this.profile.is_read) {
      set_notification_count('increment');
    }
    this.profile.is_read = 0;
    this.$wachat_room.find('.last-message').css('color', 'var(--text-color)');
    this.$wachat_room.find('.wachat-latest').show();
  }

  render(mode) {
    if (mode == 'append') {
      this.$wachat_rooms_container.append(this.$wachat_room);
    } else {
      this.$wachat_rooms_container.prepend(this.$wachat_room);
    }

    this.setup_events();
    // this.addLoadMoreButton();
    setTimeout(() => this.addLoadMoreButton(), 0);

  }

  move_to_top() {
    $(this.$wachat_room).prependTo(this.$wachat_rooms_container);
  }

  setup_events() {
    this.$wachat_room.on('click', () => {
      if (typeof this.wachat_space !== 'undefined') {
        this.wachat_space.render();
      } else {
        this.wachat_space = new WachatSpace({
          $wrapper: this.$wrapper,
          wachat_list: this.wachat_list,
          profile: this.profile,
        });
      }
      if (this.profile.is_read === 0) {
        mark_message_read(this.profile.room_name);

        this.set_as_read();
      }
    });
  }
}